// extracted by mini-css-extract-plugin
module.exports = {"ErrorBox":"ErrorBox_ErrorBox__1ul3n","Active":"ErrorBox_Active__361iP","fadein":"ErrorBox_fadein__3Ny0s"};